import { SensorsDataResult, Row, Axis } from "../../../../../rest/Geotab";
import { SensorsDataActions } from "../flux";
import { TimeSeriesActions } from "../../../../../charts/TimeSeries/flux/TimeSeriesActions";
import { getTitle } from "../utils";
import { Key } from "../../../../../models";
import { IDataSet, SequenceState } from "../../../../../charts/Data";
import { GoogleMapLoader } from "../../../../utils/GoogleMapLoader";
import { FlagActions } from "../../../../flux/Flag";
import { appNavigator } from "../../../../routes";
import { Command1 } from "../../../../../Command";

export class ShowSensorsDataCommand implements Command1<SensorsDataResult>
{
    private readonly sensorsDataActions = new SensorsDataActions();
    private readonly timeseriesActions = new TimeSeriesActions();
    private readonly alertActions = new FlagActions();
    
    constructor(private googleMapLoader: GoogleMapLoader, private alertDispatchToken: string)
    {
    }

    execute = (resp: SensorsDataResult) => {
        const { Rows } = resp;
        const hasReadings = Rows.some(row => row.Readings.length > 0);
        if(hasReadings) {
            this.sensorsDataActions.setSensorsData(resp);
            this.timeseriesActions.setDataSets(convertSensorData(resp.Rows, resp.Axes));
            return this.googleMapLoader.loadMapFor(resp.Gapik)
                .then(appNavigator.goToSensorsDataPage);
        } else {
            this.alertActions.set(this.alertDispatchToken);
        }
    }
}

interface Group {
	RangeMin?: number;
	RangeMax?: number;
	Rows: Row[];
}

const colors = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
function convertSensorData(rows: Row[], axes: Axis[]): IDataSet[]
{
    const map = rows.reduce((acc, r, idx) => {
        r.order = idx;
        return acc.set(r.id, r);
    }, new Map<Key, Row>());
    const groups = axes.map<Group>((axis, idx) => ({
        RangeMax: axis.RangeMax,
        RangeMin: axis.RangeMin,
        Rows: axis.SensorIds.map(id => {
            const row = map.get(id);
            map.delete(id);
            return row;
        })
    }));
    map.forEach((row, id) => groups.push({ Rows: [row] }));

    let colorIdx = 0;
    groups.forEach(g => g.Rows = g.Rows.filter(r => r.Readings.length > 1));
    return groups.filter(g => g.Rows.length > 0) .map<IDataSet>((group, idx) => ({
        yAxisTitle: group.Rows.length === 1 ? getTitle(group.Rows[0]) : group.Rows[0].UnitName,
        maxValue: group.RangeMax,
        minValue: group.RangeMin || 0,
        sequences: group.Rows.map((r, index) => ({
            id: colorIdx,
            color: colors[colorIdx++ % colors.length],
            title: getTitle(r),
            dotType: r.DotType,
            order: r.order,
            state: SequenceState.Normal,
            BaselineValue: group.Rows[index].Baseline,
            samples: r.Readings.map(item => ({
                x: new Date(item.DateTime),
                y: item.Value,
                severity: item.POI
            }))
        }))
    }));
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/commands/ShowSensorsDataCommand.ts